import AwbTpsImportPage from "./import/import_awb";
import AwbTpsImportForm from "./import/import_awb/form";
import AwbTpsImportEditAwbForm from "./import/import_awb/editawb";
import AwbTpsImportEditHeaderFlight from "./import/import_awb/editHeaderFlight";
import AwbTpsImportHawbForm from "./import/import_awb/hawbform";
import ImportInPage from "./import/import_in";
import ImportInForm from "./import/import_in/form";
import ImportVerifyPage from "./import/import_verify";
import ImportVerifyForm from "./import/import_verify/form";

import ImportReport from "./import/import_report";

export const Routing = [
    {
        to: "/import/awb",
        level: 0x1fff,
        component: <AwbTpsImportPage />
    },
    {
        to: "/import/awb_form",
        level: 0x1fff,
        component: <AwbTpsImportForm />
    },
    {
        to: "/import/flight_editform",
        level: 0x1fff,
        component: <AwbTpsImportEditHeaderFlight />
    },
    {
        to: "/import/awb_edit",
        level: 0x1fff,
        component: <AwbTpsImportForm />
    },
    {
        to: "/import/awb_editform",
        level: 0x1fff,
        component: <AwbTpsImportEditAwbForm />
    },
    {
        to: "/import/awb_hawbform",
        level: 0x1fff,
        component: <AwbTpsImportHawbForm />
    },

    {
        to: "/import/import_in",
        level: 0x1ff2,
        component: <ImportInPage />
    },
    {
        to: "/import/import_in/form",
        level: 0x1ff2,
        component: <ImportInForm />
    },

    {
        to: "/import/import_verify",
        level: 0x1ff2,
        component: <ImportVerifyPage />
    },
    {
        to: "/import/import_verify/create",
        level: 0x1ff2,
        component: <ImportVerifyForm />
    },
    {
        to: "/import/import_verify/edit",
        level: 0x1ff2,
        component: <ImportVerifyForm />
    },

    {
        to: "/import/import_report",
        level: 0x1ff2,
        component: <ImportReport />
    },
];
